<ham-modal
    [title]="vendor.displayNameKey | i18next"
    [saveText]="'aumico_button_ok' | i18next"
    [showCancelButton]="false"
    [size]="'sm'"
    (save)="onClose()"
    (cancel)="onClose()"
>
    <div class="vendor-redirect-modal">
        <!-- Per-company vendor (Bexio) shown on the Org Settings: managed per company. -->
        <p class="vendor-redirect-modal__hint">
            {{ 'aumico_org_integration_redirect_managed_in_company' | i18next }}
        </p>
    </div>
</ham-modal>
